import { get } from 'svelte/store'
import { currentSheet, vendors } from './root.js'
import Api from '../services/Api'

export const saveItem = async ({
  vendorId,
  sheetId,
  item,
  variation,
  details,
}) => {
  const payload = {
    item,
    variation,
    sheetId,
    vendorId,
    details,
  }

  if (item.id) {
    return await Api.put('/inventory', payload)
  } else {
    return await Api.post('/inventory', payload)
  }
}

export const updateDetail = async (detailId, fields) => {
  const result = await Api.put(`/details/${detailId}`, fields)

  if (result.status === 200) {
    const $currentSheet = get(currentSheet)

    if ($currentSheet.items.length > 0) {
      const updates = { ...fields }
      if (fields.vendor !== undefined) {
        const $vendors = get(vendors)
        updates.vendor =
          $vendors.find((vendor) => vendor.id === fields.vendor) || null
      }

      currentSheet.update((sheet) => ({
        ...sheet,
        items: sheet.items.map((item) => {
          if (!item.details.find((detail) => detail.id === detailId)) {
            return item
          }
          return {
            ...item,
            details: item.details.map((detail) =>
              detail.id === detailId ? { ...detail, ...updates } : detail
            ),
          }
        }),
      }))
    }
  }

  return result
}

export const deleteDetail = async (detailId) => {
  const result = await Api.delete(`/details/${detailId}`)

  if (result.status === 200) {
    const $currentSheet = get(currentSheet)
    if ($currentSheet.items.length > 0) {
      currentSheet.update((sheet) => {
        const { items, ...rest } = sheet
        const newItems = items.map((item) => {
          if (!item.details.find((detail) => detail.id === detailId)) {
            return item
          } else if (item.details.length === 1) {
            return null
          } else {
            return {
              ...item,
              details: item.details.filter((detail) => detail.id !== detailId),
            }
          }
        })

        return {
          ...rest,
          items: newItems.filter((item) => item !== null),
        }
      })
    }
  }
}
